export const timingTabInfoSelector = (state) => state.timingTab.timingTabInfo;
export const timingLoadingSelector = (state) =>
  state.timingTab.isLoadingTimingTab;
